export default {
  init() {
    // JavaScript to be fired on all pages
    var totalPages = $('#totalPages').val();

    if(totalPages <= '1')
    {
        $('.page-pagination').hide();
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired



    $('.mb-menu-close').click(function() {
        $('body').removeClass('no-scroll');
    });

    $('.navbar-toggler').click(function(){
        $('body').addClass('no-scroll');
    });

    /*Menu close*/ 
    $("nav.navbar .close-btn").on("click", function(){
        $("nav.navbar .navbar-collapse").removeClass("show");
    });
    /*Menu close*/ 

    if (jQuery(window).width() <= 1199.5){
        (function ($) {
            $.fn.menumaker = function (options) {
                var cssmenu = $(this),
                    settings = $.extend({
                        format: "dropdown",
                        sticky: false
                    }, options);
                return this.each(function () {
                    $(this).find(".navbar-toggler").on('click', function () {
                        $(this).toggleClass('menu-opened');
                        var mainmenu = $(this).next('ul');
                        if (mainmenu.hasClass('open')) {
                            mainmenu.slideToggle().removeClass('open');
                        } else {
                            mainmenu.slideToggle().addClass('open');
                            if (settings.format === "dropdown") {
                                mainmenu.find('ul').show();
                            }
                        }
                    });
                    cssmenu.find('li ul').parent().addClass('has-sub');
                    function multiTg() {
                        cssmenu.find(".has-sub").prepend('<span class="submenu-button"><i class="fa fa-angle-right"></span>');
                        cssmenu.find('.submenu-button').on('click', function () {
                            $(this).toggleClass('submenu-opened');
                            if ($(this).siblings('ul').hasClass('open')) {
                                $(this).siblings('ul').removeClass('open').slideToggle();
                            } else {
                                $(this).siblings('ul').addClass('open').slideToggle();
                            }
                        });
                        cssmenu.find('a').on('click', function () {
                            if($(this).attr('href') == '#')
                            {
                                $(this).siblings('span').toggleClass('submenu-opened');
                                if ($(this).siblings('ul').hasClass('open')) {
                                    $(this).siblings('ul').removeClass('open').slideToggle();
                                } else {
                                    $(this).siblings('ul').addClass('open').slideToggle();
                                }
                            }
                        });

                    };
                    if (settings.format === 'multitoggle') multiTg();
                    else cssmenu.addClass('dropdown');
                    if (settings.sticky === true) cssmenu.css('position', 'fixed');
                    function resizeFix() {
                        var mediasize = 1000;
                        if ($(window).width() > mediasize) {
                            cssmenu.find('ul').show();
                        }
                        if ($(window).width() <= mediasize) {
                            cssmenu.find('ul').hide().removeClass('open');
                        }
                    };
                    resizeFix();
                    return $(window).on('resize', resizeFix);
                });
            };
        })(jQuery);

        (function ($) {
            $(document).ready(function () {
                $("#menu-main-menu").menumaker({
                    format: "multitoggle"
                });
            });
        })(jQuery);

    }

    /*Sticky Header*/
    $(function () {
        $(window).on("scroll", function () {
            if ($(window).width() > 0) {
                if ($(window).scrollTop() > 50) {
                    $(".header").addClass("header-sticky");
                } else {
                    //remove the background property so it comes transparent again (defined in your css)
                    $(".header").removeClass("header-sticky");
                }
            }
        });
    });
    /*Sticky Header*/

    $('#owl-carousel, #owl-carousel3').owlCarousel({
        navigation: true, // Show next and prev buttons
        slideSpeed: 1000,
        nav: true,
        autoplay: true,
        autoplayTimeout: 5000,
        paginationSpeed: 5000,
        singleItem: true,
        loop: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });

    $('#owl-carousel2').owlCarousel({
        navigation: true, // Show next and prev buttons
        slideSpeed: 1000,
        nav: true,
        autoplay: true,
        autoplayTimeout: 5000,
        paginationSpeed: 5000,
        singleItem: true,
        loop: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 4
            }
        }
    });

    $('.mem-show').click(function() {
        var mem_id = $(this).attr('mem-id');
        var mem_name  = $('.mem-name-'+mem_id).text();
        var mem_desc = $('.mem-desc-'+mem_id).html();
        var mem_img = $('.mem-img-'+mem_id).attr('src');

        $('#mem-modal-img').attr('src',mem_img);
        $('#mem-modal-name').text(mem_name);
        $('#mem-modal-details').html(mem_desc);
        $('#member').modal('show');
    });

    $('#rental-modal li a').click(function() {
        $('#rental-modal li').removeClass('active');
        $(this).closest('li').addClass('active');
    }); 

    $('.scrollbar-inner').scrollbar();

    if($('#totalPages').val() >0) {

        var totalPages = ($('#totalPages').val() >0)?($('#totalPages').val()):0;
        $('#global-pagination').twbsPagination({
            totalPages: totalPages,
            startPage: 1,
            visiblePages: totalPages>6?6:totalPages,
            initiateStartPageClick: true,
            href: false,
            hrefVariable: '{{number}}',
            prev: 'Previous',
            next: 'Next',
            loop: false,
            onPageClick: function (event, page) {
                $('.page-active').removeClass('page-active');
                $('#page'+page).addClass('page-active');
            },
            paginationClass: '',
            nextClass: 'next',
            prevClass: 'prev',
            pageClass: 'pagi',
            activeClass: 'active',
            disabledClass: 'disabled',
        });

    }

    /*Faq-accordion*/
    jQuery('.collapse').on('show.bs.collapse', function () {
        jQuery(this).siblings('.card-header').addClass('active');
    });

    jQuery('.collapse').on('hide.bs.collapse', function () {
        jQuery(this).siblings('.card-header').removeClass('active');
    });
    /*Faq-accordion*/

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js